import icProgramArt from "@/assets/images/user/icProgramArt.svg";
import programArtCont1Img1 from "@/assets/images/user/programArtCont1Img1.jpg";
import programArtCont1Img2 from "@/assets/images/user/programArtCont1Img2.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

const programList = [
    {
        title: "GXG 아트북 라운지",
        background: "bg-program202503",
        img: icProgramArt,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9/19(금)~9/20(토), 11:00 ~ 21:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            판교 테크원 1F 로비
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            게임, 디자인, 애니메이션, 제품 <br className="md:hidden" />
                            디자인까지! <br />
                            4가지 주제로 구성된 게임 그래픽 <br className="md:hidden" />
                            아트북을 자유롭게 감상하세요.
                        </p>
                    </li>
                </ul>
                <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programArtCont1Img1} alt="이미지" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: "GXG 씨어터",
        background: "bg-program202503",
        img: icProgramArt,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9/19(금) 13:00~14:00, 20:50~21:30 <br />
                            9/20(토) 13:00~14:15, 14:15~15:15, 20:50~21:45
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            북측광장 B - SUB STAGE
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            유저들의 상상력이 빚어낸 <br className="md:hidden" />
                            특별한 작품과 함께 영상 속 <br className="md:hidden" />
                            여행을 떠나볼까요? <br />
                            상영전 진행되는 선착순 이벤트도 <br className="md:hidden" />
                            놓치지 마세요.
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>상영작</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9/19(금) <br />
                            13:00 ~ 14:00 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt; - 1회
                            <br />
                            20:50 ~ 21:30 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt; - 2회
                            <br />
                            <br />
                            9/20(토) <br />
                            13:00 ~ 14:15 HoYoFair 기념 &lt;젠레스 존 제로, 2차 창작 특별 프로그램&gt;
                            <br />
                            14:15 ~ 15:15 2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt; - 1회
                            <br />
                            20:50 ~ 21:45 2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt; - 2회
                            <br />
                            <br />
                            ※ 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt;과 <br />
                            2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt;은 각각 1, 2회차로 분할
                            상영합니다. <br />※ 현장 상황에 따라 시간 및 내용이 변동될 수 있습니다.
                        </p>
                    </li>
                </ul>
                <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programArtCont1Img2} alt="이미지" className="w-full" />
                </div>
            </div>
        ),
    },
];

export default function Art() {
    return (
        <>
            <div className="p-[48px_0_20px] xl:pt-[60px] text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px] xl:text-right">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
            />
        </>
    );
}
